import { useState, useEffect } from 'react';
import { useBetslipStore } from '@/store/betslip';
import { useTranslations } from 'next-intl';

interface TooltipProps {
  ticketKey: string;
}

export const Tooltip = ({ ticketKey }: TooltipProps) => {
	const translate = useTranslations('General');
	const [timeoutKey, setTimeoutKey] = useState(0);
	const [isOpen, setIsOpen] = useState(false);
	const [message, setMessage] = useState('');

	const [tooltipMap, clearTooltip] = useBetslipStore(state => [state.tooltipMap, state.clearTooltip]);

	const clearTooltipTimeout = () => {
		setTimeoutKey(0);
		setIsOpen(false);
		setMessage('');
		clearTooltip(ticketKey);
	}

	useEffect(() => {
		const message = tooltipMap.get(ticketKey);

		if (message) {
			if (timeoutKey) {
				window.clearTimeout(timeoutKey);
			}

			setIsOpen(true);
			const keys = Object.keys(message);
			const sourceKey = keys[0];
			const value = (message[sourceKey].value ?? 0).toString();
			setMessage(translate(sourceKey, { 0: value as string }));

			const key = window.setTimeout(() => {
				clearTooltipTimeout();
			}, 3000);

			setTimeoutKey(key);
		} else {
			clearTooltipTimeout();
		}
	}, [tooltipMap]);

	return (
		<div className="tip" data-open={isOpen}>
			<div className="scrollbar scrollbar--tip">
				<div className="tip__content">{message}</div>
			</div>
		</div>
	);
}